"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VsmLastSentAlertEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const VsmLastSentAlertDto_1 = require("./VsmLastSentAlertDto");
const VehicleDropOffDto_1 = require("../vehicle-drop-offs/VehicleDropOffDto");
const VehicleDropOffEntity_1 = require("../vehicle-drop-offs/VehicleDropOffEntity");
class VsmLastSentAlertEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, vsmLastSentAlert) {
        super();
        this._requiredFieldsSetStatus = {
            vehicleDropOffId: false,
            alertType: false
        };
        this._dependencies = dependencies;
        if (vsmLastSentAlert === undefined) {
            this._dto = new VsmLastSentAlertDto_1.VsmLastSentAlertDto();
        }
        else if (vsmLastSentAlert instanceof VsmLastSentAlertDto_1.VsmLastSentAlertDto) {
            this._dto = new VsmLastSentAlertDto_1.VsmLastSentAlertDto(vsmLastSentAlert);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (vsmLastSentAlert instanceof VsmLastSentAlertEntity) {
            this._dto = new VsmLastSentAlertDto_1.VsmLastSentAlertDto(vsmLastSentAlert._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new VsmLastSentAlertDto_1.VsmLastSentAlertDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getVehicleDropOff() {
        if (this._dto.vehicleDropOffId === undefined) {
            return undefined;
        }
        if (this._dto.vehicleDropOff === undefined) {
            throw new Error("Cannot call getVehicleDropOff without " +
                "first loading the VehicleDropOff.");
        }
        if (!this._vehicleDropOffEntity && this._dto.vehicleDropOff) {
            this._vehicleDropOffEntity = new VehicleDropOffEntity_1.VehicleDropOffEntity(this._dependencies, this._dto.vehicleDropOff);
        }
        return this._vehicleDropOffEntity;
    }
    getVehicleDropOffId() {
        return this._dto.vehicleDropOffId;
    }
    setVehicleDropOff(untrustedValue) {
        let untrustedId;
        if (untrustedValue instanceof VehicleDropOffEntity_1.VehicleDropOffEntity) {
            if (untrustedValue.isNew) {
                throw new BadRequestError_1.BadRequestError("untrustedValue.isNew cannot be true.");
            }
            untrustedId = untrustedValue.getId();
        }
        else if (untrustedValue instanceof VehicleDropOffDto_1.VehicleDropOffDto) {
            untrustedId = untrustedValue.id;
        }
        else {
            throw new BadRequestError_1.BadRequestError("untrustedValue is of an invalid type.");
        }
        this.setVehicleDropOffId(untrustedId);
        if (this.hasError("vehicleDropOffId")) {
            return;
        }
        if (untrustedValue instanceof VehicleDropOffEntity_1.VehicleDropOffEntity) {
            this._vehicleDropOffEntity = untrustedValue;
        }
    }
    setVehicleDropOffId(untrustedValue) {
        let _untrustedValue;
        this.clearError("vehicleDropOffId");
        this._requiredFieldsSetStatus.vehicleDropOffId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("vehicleDropOffId", "Vehicle Drop Off Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("vehicleDropOffId", "Vehicle Drop Off is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.vehicleDropOffId) {
            return;
        }
        this._dto.vehicleDropOffId = _untrustedValue;
        delete this._vehicleDropOffEntity;
        this._setIsDirty(true);
    }
    getAlertType() {
        return this._dto.alertType;
    }
    setAlertType(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("alertType");
        this._requiredFieldsSetStatus.alertType = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("alertType", "Alert Type is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("alertType", `Alert Type has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.alertType) {
            return;
        }
        this._dto.alertType = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    loadVehicleDropOffAsync(expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                if (!this.getVehicleDropOffId()) {
                    return;
                }
                this._emit("before-loadVehicleDropOffAsync");
                this._dto.vehicleDropOff =
                    yield this._dependencies.vehicleDropOffDatastore
                        .getAsync(this.getVehicleDropOffId(), expand);
                delete this._vehicleDropOffEntity;
                this._emit("after-loadVehicleDropOffAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    loadAsync(id, expand) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.vsmLastSentAlertDatastore
                    .getAsync(id, expand);
                delete this._vehicleDropOffEntity;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Vsm Last Sent Alert is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.vsmLastSentAlertDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.vsmLastSentAlertDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Vsm Last Sent Alert cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.vsmLastSentAlertDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.VsmLastSentAlertEntity = VsmLastSentAlertEntity;
//# sourceMappingURL=VsmLastSentAlertEntity.js.map